import { trackAnalytics } from "@repo/utils";
import { useEffect } from "react";

export function useTrackWidgetFilters(
  name: string,
  isValidating: boolean,
  settings: Record<string, any> = {}
) {
  useEffect(() => {
    if (!isValidating) {
      const activeFilters = Object.keys(settings).reduce((acc, key) => {
        const configuredValue = settings[key];
        if (configuredValue !== undefined) {
          if (Array.isArray(configuredValue)) {
            acc = configuredValue.length > 0 ? acc + 1 : acc;
          } else {
            acc++;
          }
        }

        return acc;
      }, 0);

      trackAnalytics("widget_settings", {
        name,
        activeFilters,
      });
    }
  }, [isValidating, name, settings]);
}
